module.exports = __webpack_public_path__ + "static/cities-list-0b3d657f9f2e23cec94c30428850103e.gif";